var _style, _path, _path2, _path3, _path4, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMealTimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B82455;}\n\t.st1{fill:#EFC05D;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:3.5;stroke-linecap:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,183.2c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.7,148.7,63.5,183.2,106.3,183.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.2,141.9c19.8,0,35.9-15.9,35.9-35.6c0-19.7-16.1-35.6-35.9-35.6s-35.9,15.9-35.9,35.6 C70.2,126,86.3,141.9,106.2,141.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.4,71.2H62c-0.4,0-0.8,0.4-0.8,0.8v18.9c0,0.8-0.7,1.5-1.5,1.5h-0.3c-0.8,0-1.5-0.7-1.5-1.5V72 c0-0.4-0.4-0.8-0.8-0.8h-1.9c-0.4,0-0.8,0.4-0.8,0.8v18.9c0,0.8-0.7,1.5-1.5,1.5h-0.3c-0.8,0-1.5-0.7-1.5-1.5V72 c0-0.4-0.4-0.8-0.8-0.8h-1.4c-0.4,0-0.8,0.4-0.8,0.8v23.4c0,3.1,2.3,5.7,5.3,6.3v37.5c0,1.3,1,2.3,2.3,2.3h0.6c1.3,0,2.3-1,2.3-2.3 v-37.5c3-0.5,5.3-3.1,5.3-6.3V72C64.2,71.6,63.8,71.2,63.4,71.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.3,71.4c-0.5-0.5-1.1-0.8-1.8-0.8c-0.6,0-1.2,0.2-1.6,0.5c-0.3,0.3-0.6,0.6-0.8,1l0,0 c0,0.1-0.1,0.2-0.1,0.3l0,0l-7.6,22.8c-0.6,1.9-0.4,3.9,0.7,5.6l6.8,10.7v26.5c0,1.4,1.2,2.6,2.6,2.6s2.6-1.2,2.6-2.6V73.2 C162,72.5,161.7,71.9,161.3,71.4z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "106.1,80.6 106.1,106.6 118.3,120.4 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealTimes);
export default __webpack_public_path__ + "static/media/Meal_Times.735b2368b874ad50aff1ce89514d99d2.svg";
export { ForwardRef as ReactComponent };